import apiClient from './api';
import { 
  TimelineErasResponse, 
  TimelineEventsResponse, 
  TimelineEventResponse,
  UserTimelineProgressResponse,
  TimelineUnlockResponse
} from '../types/timeline';

// Get all timeline eras
export const getTimelineEras = async (): Promise<TimelineErasResponse> => {
  try {
    const response = await apiClient.get('/timeline/eras');
    return response.data;
  } catch (error) {
    console.error('Error fetching timeline eras:', error);
    throw error;
  }
};

// Get all timeline events, optionally filtered by era
export const getTimelineEvents = async (era?: string): Promise<TimelineEventsResponse> => {
  try {
    const params = era ? { era } : {};
    const response = await apiClient.get('/timeline/events', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching timeline events:', error);
    throw error;
  }
};

// Get a single timeline event by ID
export const getTimelineEvent = async (eventId: string): Promise<TimelineEventResponse> => {
  try {
    const response = await apiClient.get(`/timeline/event/${eventId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching timeline event:', error);
    throw error;
  }
};

// Get user's timeline progress (changed from token to userId)
export const getUserTimelineProgress = async (userId: string): Promise<UserTimelineProgressResponse> => {
  try {
    const response = await apiClient.get('/timeline/progress');
    return response.data;
  } catch (error) {
    console.error('Error fetching user timeline progress:', error);
    throw error;
  }
};

// Unlock a timeline event for the user
export const unlockTimelineEvent = async (eventId: string): Promise<TimelineUnlockResponse> => {
  try {
    const response = await apiClient.post(`/timeline/unlock/${eventId}`, {});
    return response.data;
  } catch (error) {
    console.error('Error unlocking timeline event:', error);
    throw error;
  }
}; 